// @owners { team: patients }
import { Button } from '@alto/design-system';
import React from 'react';
import { useAnalytics } from '~shared/hooks';
import { EVENTS } from '~shared/lib/analytics/src/constants';
import { useOrderPricing } from '~shared/queries';
import { FSA_RECEIPT_MUTATION_KEY } from '~shared/queries/constants';
import { useIsMutating } from '~shared/react-query';

type DownloadReceiptButtonProps = {
  readonly handleDownloadReceipt: () => void | Promise<void>;
  readonly shipmentID: number;
};

export const DownloadReceiptButton = ({ handleDownloadReceipt, shipmentID }: DownloadReceiptButtonProps) => {
  const { isOrderPricingLoading } = useOrderPricing();
  // The download mutation runs in the screen that renders this button; observe it by key.
  const fetchFsaReceiptLoading = useIsMutating({ mutationKey: FSA_RECEIPT_MUTATION_KEY }) > 0;
  const { trackEvent } = useAnalytics();

  const onPress = () => {
    handleDownloadReceipt();
    trackEvent({
      event: EVENTS.DELIVERY_DETAILS_DOWNLOAD_BUTTON_CLICKED,
      additionalFields: { shipmentId: shipmentID },
    });
    trackEvent({
      event: EVENTS.FSA_RECEIPT_DOWNLOAD_CLICKED,
      params: { receiptType: 'single_order', source: 'patient_app_order_details' },
      additionalFields: { shipmentId: shipmentID },
    });
  };

  return (
    <Button
      accessibilityLabel="Download Receipt Button"
      label="Download Receipt"
      loading={isOrderPricingLoading || fetchFsaReceiptLoading}
      onPress={onPress}
      small
      testID="download-receipt-button"
      type="secondary"
      width="inline"
    >
      Download receipt
    </Button>
  );
};
